import {MdOutlineCastForEducation} from "react-icons/md";
import {RiMessageFill} from "react-icons/ri";
import {MdDesignServices} from "react-icons/md";
import {HiUserGroup} from "react-icons/hi"

export const education=[
    
       
        "Blog",
        "Ebooks,Guides & More",
       "Free Cources & Certifications",
        "Inbound Methodology"
    
]

export const WhyHubspot=[
   
       "Case Studies",
       "Why Choose HubSport?",
       
    
]


export const Services=[
  
       
        "Onboarding & Consulting Services",
       "Hire a Service Provider",
       
   
]

export const UserResources=[
   
       
        "Partner Programs",
      "Developer Tools",
        "Community",
        "HubSpot Ecosystem"
 
]